import { Pipe, PipeTransform } from '@angular/core';

import { ChargerOperationalStatusStoreModelEnum } from '@domain/sites/sites.enums';

import { TranslateEnumPipeBase } from '@shared/pipes/translate-enum-pipe-base';

const KEY_PREFIX = 'enums.charger-state';
export const ChargerStateKeyMapping: Record<ChargerOperationalStatusStoreModelEnum, string> = {
  [ChargerOperationalStatusStoreModelEnum.Operational]: `${KEY_PREFIX}.operational`,
  [ChargerOperationalStatusStoreModelEnum.Maintenance]: `${KEY_PREFIX}.maintenance`,
  [ChargerOperationalStatusStoreModelEnum.Faulted]: `${KEY_PREFIX}.faulted`,
  [ChargerOperationalStatusStoreModelEnum.Offline]: `${KEY_PREFIX}.offline`,
};

@Pipe({
  name: 'appTranslateChargerState',
  pure: false,
  standalone: true,
})
export class TranslateChargerStatePipe extends TranslateEnumPipeBase<ChargerOperationalStatusStoreModelEnum> implements PipeTransform {
  protected readonly valueTranslateKeyMap = ChargerStateKeyMapping;
}
